import { render, staticRenderFns } from "./FragmentQuiz.vue?vue&type=template&id=1272de29"
import script from "./FragmentQuiz.vue?vue&type=script&lang=ts"
export * from "./FragmentQuiz.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports